import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconCurrencyPesos: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="currency-pesos, money"><path d="M20.25 10.75H3.75" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square" strokeLinejoin="round"/><path d="M20.25 6.75H3.75" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square" strokeLinejoin="round"/><path d="M6.75 21.25V2.75H12.4044C15.7137 2.75 18.3981 5.42937 18.4044 8.73864C18.4107 12.0568 15.7226 14.75 12.4044 14.75H7.29546" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/></CentralIconBase>;
};

export default IconCurrencyPesos;
